import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import ContentPageTranslation from '@/repositories/data/content/ContentPageTranslation';

export default class ContentPageTranslationRepository extends BaseCrudRepository<
    number,
    ContentPageTranslation,
    ContentPageTranslation
> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/page-translation/');
    }
}
